import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";

export const AppEInvoiceExemptedModal = (props, ref) => {
	const [visible, setVisible] = useState(false);
	const { onHandleConfirm } = props;

	const onHandleShow = useCallback(() => {
		setVisible(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
	}, []);

	const onHandleConfirmExemption = useCallback(() => {
		setVisible(false);
		onHandleConfirm();
	}, [onHandleConfirm]);

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-e-invoice-exempted-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="e-invoice-exempted-modal" aria-describedby="e-invoice-exempted-modal">
			<div className="e-invoice-exempted-modal">
				<div className="e-invoice-exempted-modal__main">
					<div className="e-invoice-exempted-modal__header">
						<p className="e-invoice-exempted-modal__title">E-Invoice Exempted</p>
					</div>

					<div className="e-invoice-exempted-modal__body">
						<p className="e-invoice-exempted-modal__description">Are you sure this claim is E-Invoice exempted?</p>

						<div className="e-invoice-exempted-modal__button-container">
							<AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} />
							<AppButton type="button" label="Confirm" onClick={onHandleConfirmExemption} />
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppEInvoiceExemptedModal));

AppEInvoiceExemptedModal.propTypes = {
	ref: PropTypes.object,
	onHandleConfirm: PropTypes.func.isRequired,
};
